import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=cfa60eae&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfa60eae')) {
      api.createRecord('cfa60eae', component.options)
    } else {
      api.reload('cfa60eae', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=cfa60eae&", function () {
      api.rerender('cfa60eae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2C07swQ0fYdp1/JS/imageCarousel.vue"
export default component.exports